// from here node_modules/@ifg/drupal_base_theme/source/core/scss/vars.scss
export const breakpoints = {
  xs: '0px',
  sm: '700px',
  md: '1400px',
  lg: '2000px',
};
